<template>
    <!--
      作者：bbc_team
      时间：2023-06-08
      描述：订单详情
  -->
    <div v-loading="loading" class="pb50">
        <!--订单进度-->
        <!-- <el-steps :active="active" finish-status="success">
        <el-step title="下单时间"></el-step>
        <el-step title="付款"></el-step>
        <el-step title="发货"></el-step>
        <el-step title="收货"></el-step>
        <el-step title="完成"></el-step>
        </el-steps> -->
        <!--内容-->
        <div class="goods-content">
            <!--基本信息-->
            <div class="common-form">基本信息</div>
            <div class="table-wrap">
                <el-row>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">订单号：</span>
                            {{ detail.order_no }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">买家：</span>
                            {{ detail.user.nickName }}
                            <span>用户ID：({{ detail.user.user_id }})</span>
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">订单金额 (元)：</span>
                            {{ detail.order_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">运费金额 (元)：</span>
                            {{ detail.express_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div v-if="detail.coupon_money > 0" class="pb16">
                            <span class="gray9">优惠券抵扣 (元)：</span>
                            {{ detail.coupon_money }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div v-if="detail.points_money > 0" class="pb16">
                            <span class="gray9">积分抵扣 (元)：</span>
                            {{ detail.points_money }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div v-if="detail.fullreduce_money > 0" class="pb16">
                            <span class="gray9">满减金额 (元)：</span>
                            {{ detail.fullreduce_money }}
                        </div>
                    </el-col>
                    <el-col v-if="detail.order_source == 70" :span="5">
                        <div class="pb16">
                            <span class="gray9">定金：</span>
                            {{ detail.advance.pay_price }}
                        </div>
                    </el-col>
                    <el-col v-if="detail.order_source == 70" :span="5">
                        <div class="pb16">
                            <span class="gray9">尾款：</span>
                            {{ detail.total_price }}
                        </div>
                    </el-col>
                    <el-col v-if="detail.order_source == 70 && detail.advance.reduce_money" :span="5">
                        <div class="pb16">
                            <span class="gray9">尾款立减：</span>
                            {{ detail.advance.reduce_money }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">实付款金额 (元)：</span>
                            {{ detail.pay_price }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">支付方式：</span>
                            {{ detail.pay_type.text }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">配送方式：</span>
                            {{ detail.delivery_type.text }}
                        </div>
                    </el-col>
                    <el-col :span="5">
                        <div class="pb16">
                            <span class="gray9">交易状态：</span>
                            {{ detail.order_status.text }}
                        </div>
                    </el-col>
                    <el-col v-if="detail['pay_status']['value'] == 10 && detail['order_status']['value'] == 10 && detail['order_source'] == 10" v-auth="'/order/order/updatePrice'" :span="5">
                        <el-button size="small" @click="editClick(detail)">修改价格</el-button>
                    </el-col>
                </el-row>
            </div>
            <!--编辑-->
            <Add v-if="open_edit" :open_edit="open_edit" :order="userModel" @close="closeDialogFunc($event, 'edit')"></Add>

            <!--商品信息-->
            <div class="common-form mt16">商品信息</div>
            <div class="table-wrap">
                <el-table size="small" :data="detail.goods" border style="width: 100%">
                    <el-table-column prop="goods_name" label="商品" width="400">
                        <template slot-scope="scope">
                            <div class="goods-info">
                                <div class="pic"><img v-img-url="scope.row.image.file_path"/></div>
                                <div class="info">
                                    <div class="name">{{ scope.row.goods_name }}</div>
                                    <div v-if="scope.row.goods_attr != ''" class="gray9">{{ scope.row.goods_attr }}</div>
                                    <div v-if="scope.row.refund" class="orange"> {{ scope.row.refund.type.text }}-{{ scope.row.refund.status.text }} </div>
                                    <div class="price">
                                        <span :class="{ 'text-d-line': scope.row.is_user_grade == 1, gray6: scope.row.is_user_grade != 1 }">￥ {{ scope.row.goods_price }}</span>
                                        <span v-if="scope.row.is_user_grade == 1" class="ml10"> 会员折扣价：￥ {{ scope.row.grade_goods_price }} </span>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="goods_no" label="商品编码"></el-table-column>
                    <el-table-column prop="goods_weight" label="重量 (Kg)"></el-table-column>
                    <el-table-column prop="total_num" label="购买数量">
                        <template slot-scope="scope">
                            <p>x {{ scope.row.total_num }}</p>
                        </template>
                    </el-table-column>
                    <el-table-column prop="total_price" label="商品总价(元)">
                        <template slot-scope="scope">
                            <p>￥ {{ scope.row.total_price }}</p>
                        </template>
                    </el-table-column>
                </el-table>
            </div>

            <!--收货信息-->
            <div v-if="detail.delivery_type.value == 10">
                <div class="common-form mt16">收货信息</div>
                <div class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">收货人：</span>
                                {{ detail.address.name }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">收货电话：</span>
                                {{ detail.address.phone }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">收货地址：</span>
                                {{ detail.address.region.province }} {{ detail.address.region.city }} {{ detail.address.region.region }}
                                {{ detail.address.detail }}
                            </div>
                        </el-col>
                        <el-col v-if="detail.delivery_status.value != 20 && detail.order_status.value == 10" :span="5">
                            <div class="pb16">
                                <el-button type="text" size="small" @click="changeAdd"> 修改地址</el-button>
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="25">
                            <div class="pb16">
                                <span class="gray9">备注：</span>
                                {{ detail.buyer_remark }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <!--发货信息-->
            <div v-if="detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1" v-auth="'/order/order/delivery'">
                <div v-if="detail.delivery_status.value == 10">
                    <!-- 去发货 -->
                    <div class="common-form mt16">去发货</div>
                    <el-form ref="form" size="small" label-width="100px">
                        <el-form-item v-for="(v,k) in detail.supplier" :key="k">
                            <span slot="label">{{ v.supplier ? v.supplier.supplier_name : '自营' }}</span>
                            <span>物流公司</span>
                            <el-select v-model="v.express_id" placeholder="请选择快递公司" @change="changeExpress($event,k)">
                                <el-option v-for="(item, index) in expressList" :key="index" :label="item.express_name" :value="item.express_id"></el-option>
                            </el-select>
                            <span class="ml10">物流单号</span>
                            <el-input v-model="v.express_no" class="max-w460"></el-input>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else="">
                    <div class="common-form mt16">发货信息</div>
                    <div class="table-wrap" v-for="(v,k) in detail.supplier" :key="k">
                        <el-row>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">供应商：</span>
                                    {{ v.supplier ? v.supplier.supplier_name : '自营' }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">物流公司：</span>
                                    {{ v.express_company }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">物流单号：</span>
                                    {{ v.express_no }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">发货状态：</span>
                                    {{ v.delivery_status.text }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">发货时间：</span>
                                    {{ v.delivery_time }}
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                </div>
            </div>

            <!--自提门店信息-->
            <template v-if="detail.delivery_type.value == 20">
                <div class="common-form mt16">自提用户信息</div>
                <div v-if="detail.extract" class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">联系人：</span>
                                {{ detail.extract.linkman }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">联系电话：</span>
                                {{ detail.extract.phone }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="25">
                            <div class="pb16">
                                <span class="gray9">备注：</span>
                                {{ detail.buyer_remark }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
                <div class="common-form mt16">自提信息</div>
                <div v-if="detail.extract" class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">门店ID：</span>
                                {{ detail.extractStore.store_id }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">门店名称：</span>
                                {{ detail.extractStore.store_name }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">联系人：</span>
                                {{ detail.extractStore.linkman }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">联系电话：</span>
                                {{ detail.extractStore.phone }}
                            </div>
                        </el-col>
                        <el-col :span="15">
                            <div class="pb16">
                                <span class="gray9">门店地址：</span>
                                {{ detail.extractStore.region.province }}- {{ detail.extractStore.region.city }}- {{ detail.extractStore.region.region }}-
                                {{ detail.extractStore.address }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>

            <!--无需发货-->
            <template v-if="detail.delivery_type.value == 30">
                <div class="common-form mt16">用户信息</div>
                <div class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">联系手机：</span>
                                {{ detail.user.mobile }}
                            </div>
                        </el-col>
                    </el-row>
                    <el-row>
                        <el-col :span="25">
                            <div class="pb16">
                                <span class="gray9">备注：</span>
                                {{ detail.buyer_remark }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </template>

            <!--付款信息-->
            <div v-if="detail.pay_status.value == 20" class="table-wrap">
                <div class="common-form mt16">付款信息</div>
                <div class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">应付款金额：</span>
                                {{ detail.pay_price }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">余额抵扣金额：</span>
                                {{ detail.balance }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">在线支付金额：</span>
                                {{ detail.online_money }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">支付方式：</span>
                                {{ detail.pay_type.text }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">支付流水号：</span>
                                {{ detail.transaction_id }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">付款状态：</span>
                                {{ detail.pay_status.text }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">付款时间：</span>
                                {{ detail.pay_time }}
                            </div>
                        </el-col>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">收货时间：</span>
                                {{ detail.receipt_time }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <!--取消信息-->
            <div v-if="detail.order_status.value == 20 && detail.cancel_remark != ''" class="table-wrap">
                <div class="common-form mt16">取消信息</div>
                <div class="table-wrap">
                    <el-row>
                        <el-col :span="5">
                            <div class="pb16">
                                <span class="gray9">商家备注：</span>
                                {{ detail.cancel_remark }}
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>

            <!--  用户取消订单 -->
            <div v-if="detail.pay_status.value == 20 && detail.order_status.value == 21" v-auth="'/order/operate/confirmCancel'">
                <div class="common-form mt16">用户取消订单</div>
                <p class="red pb16">当前买家已付款并申请取消订单，请审核是否同意，如同意则自动退回付款金额（微信支付原路退款）并关闭订单。</p>
                <el-form ref="forms" size="small" :model="forms">
                    <el-form-item label="审核状态">
                        <div>
                            <el-radio v-model="forms.is_cancel" :label="1">同意</el-radio>
                            <el-radio v-model="forms.is_cancel" :label="0">拒绝</el-radio>
                        </div>
                    </el-form-item>
                    <el-form-item label="拒绝原因" v-if="forms.is_cancel===0">
                        <el-input v-model="forms.cancel_remark" type="textarea" placeholder="请输入拒绝原因"></el-input>
                    </el-form-item>

                    <!-- <el-form-item><el-button type="primary" @click="confirmCancel()">确认审核</el-button></el-form-item> -->
                </el-form>
            </div>

            <!--门店自提核销-->
            <div v-if="detail.delivery_type.value == 20 && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20" v-auth="'/order/operate/extract'">
                <div class="common-form mt16">门店自提核销</div>
                <div v-if="detail.delivery_status.value == 10">
                    <el-form ref="extract_form" size="small" :model="extract_form" label-width="100px">
                        <el-form-item label="门店核销员">
                            <el-select v-model="extract_form.order.extract_clerk_id" placeholder="点击选择">
                                <el-option v-for="(item, index) in shopClerkList" :key="item.clerk_id" :label="item.real_name" :value="item.clerk_id"></el-option>
                            </el-select>
                        </el-form-item>
                        <el-form-item label="买家取货状态 ">
                            <el-radio v-model="extract_form.order.extract_status" :label="1">已取货</el-radio>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onExtract(detail.order_id)">确认核销</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else class="table-wrap">
                    <template v-if="detail.extractClerk">
                        <el-row>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">自提门店名称：</span>
                                    {{ detail.extractStore.store_name }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">核销员：</span>
                                    {{ detail.extractClerk.real_name }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">核销状态：</span>
                                    <template v-if="detail.delivery_status.value == 20">
                                        已核销
                                    </template>
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">核销时间：</span>
                                    {{ detail.delivery_time }}
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </div>
            <!--虚拟物品发货-->
            <div v-if="detail.delivery_type.value == 30 && detail.pay_status.value == 20 && detail.order_status.value != 21 && detail.order_status.value != 20" v-auth="'/order/order/delivery'">
                <div class="common-form mt16">虚拟商品发货</div>
                <div v-if="detail.delivery_status.value == 10">
                    <el-form ref="virtual_form" size="small" :model="virtual_form" label-width="100px">
                        <el-form-item label="发货信息">
                            <el-input v-model="virtual_form.virtual_content" class="max-w460"></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="onVirtual(detail.order_id)">确认发货</el-button>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-else class="table-wrap">
                    <template v-if="detail.virtual_content">
                        <el-row>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">发货信息：</span>
                                    {{ detail.virtual_content }}
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">发货状态：</span>
                                    <template v-if="detail.delivery_status.value == 20">
                                        已发货
                                    </template>
                                </div>
                            </el-col>
                            <el-col :span="5">
                                <div class="pb16">
                                    <span class="gray9">发货时间：</span>
                                    {{ detail.delivery_time }}
                                </div>
                            </el-col>
                        </el-row>
                    </template>
                </div>
            </div>

            <!--订单续费周期-->
            <div v-if="cycle.length">
                <div class="common-form mt16">订单续费周期</div>
                <div class="table-wrap">
                    <el-table :data="cycle" border height="500" style="width: 1400px;">
                        <el-table-column prop="cycle_index" label="期数"></el-table-column>
                        <el-table-column prop="start_pay_time" label="开始续费时间"></el-table-column>
                        <el-table-column prop="end_pay_time" label="最晚续费时间"></el-table-column>
                        <el-table-column prop="pay_time_text" label="实际续费时间"></el-table-column>
                        <el-table-column prop="pay_status_text" label="付款状态"></el-table-column>
                        <el-table-column prop="type_text" label="续费类型"></el-table-column>
                        <el-table-column label="保证金退还状态">
                            <template slot-scope="scope">
                                {{ scope.row.refund_bond_status == 1 ? '已退还' : '未退还' }}
                            </template>
                        </el-table-column>
                        <el-table-column prop="refund_bond_price" label="退还保证金金额"></el-table-column>
                        <el-table-column prop="refund_bond_time_text" label="保证金退还时间"></el-table-column>
                    </el-table>
                </div>
            </div>

            <!--订单续费记录-->
            <div v-if="renew.length">
                <div class="common-form mt16">订单续费记录</div>
                <div class="table-wrap">
                    <el-table :data="renew" border height="500" style="width: 1200px;">
                        <el-table-column prop="order_renew_no" label="续费记录编号"></el-table-column>
                        <el-table-column prop="cycles" label="本次续费期数"></el-table-column>
                        <el-table-column prop="less_cycles" label="剩余未续费期数"></el-table-column>
                        <el-table-column prop="refund_bond_cycles" label="退回保证金期数"></el-table-column>
                        <el-table-column prop="refund_bond_price" label="退回保证金"></el-table-column>
                        <el-table-column prop="less_bond" label="剩余保证金"></el-table-column>
                        <el-table-column prop="price" label="实付金额"></el-table-column>
                        <el-table-column prop="cunzan_coin" label="赠送村赞币"></el-table-column>
                        <el-table-column prop="pay_type_text" label="支付方式"></el-table-column>
                        <el-table-column prop="pay_source_text" label="支付来源"></el-table-column>
                        <el-table-column prop="pay_status_text" label="付款状态"></el-table-column>
                        <el-table-column prop=pay_time_text label="付款时间"></el-table-column>
                        <el-table-column prop="balance" label="余额抵扣"></el-table-column>
                        <el-table-column prop="online_money" label="在线支付"></el-table-column>
                    </el-table>
                </div>
            </div>

        </div>
        <div class="common-button-wrapper">
            <el-button size="small" type="info" @click="cancelFunc">返回上一页</el-button>
            <!--确认发货-->
            <template v-if="detail.pay_status.value == 20 && detail.delivery_type.value == 10 && [20, 21].indexOf(detail.order_status.value) === -1">
                <el-button v-if="detail.delivery_status.value == 10" size="small" type="primary" @click="onSubmit">确认发货 </el-button>
            </template>
            <!--用户取消-->
            <template v-if="detail.pay_status.value == 20 && detail.order_status.value == 21">
                <el-button size="small" type="primary" @click="confirmCancel()">确认审核</el-button>
            </template>
        </div>
        <changeAddress :is-change="isChange" :address-data="addressData" @closeDialog="closeAddress"></changeAddress>
    </div>
</template>

<script>
    import OrderApi from "@/api/order.js";
    import Add from "./dialog/Add.vue";
    import changeAddress from "@/components/order/changeAddress.vue";
    import { deepClone } from "@/utils/base.js";
    export default {
        components: {
            Add,
            changeAddress
        },
        data() {
            return {
                active: 0,
                /*是否加载完成*/
                loading: true,
                /*订单数据*/
                detail: {
                    pay_status: [],
                    pay_type: [],
                    delivery_type: [],
                    user: {},
                    address: [],
                    goods: [],
                    order_status: [],
                    extract: [],
                    extract_store: [],
                    express: [],
                    delivery_status: [],
                    extractClerk: [],
                    // 供应商发货
                    supplier: [],
                },
                /*是否打开添加弹窗*/
                open_add: false,
                /*一页多少条*/
                pageSize: 20,
                /*一共多少条数据*/
                totalDataNumber: 0,
                /*当前是第几页*/
                curPage: 1,
                /*发货*/
                form: {
                    /*订单ID*/
                    express_id: null,
                    /*订单号*/
                    express_no: ""
                },
                forms: {
                    is_cancel: 1,
                    cancel_remark: ''
                },
                extract_form: {
                    order: {
                        extract_status: 1
                    }
                },
                /*虚拟商品发货*/
                virtual_form: {
                    virtual_content: ""
                },
                order: {},
                delivery_type: 0,
                /*配送方式*/
                exStyle: [],
                /*门店列表*/
                shopList: [],
                /*当前编辑的对象*/
                userModel: {},
                /*时间*/
                create_time: "",
                /*快递公司列表*/
                expressList: [],
                shopClerkList: [],
                /*是否打开编辑弹窗*/
                open_edit: false,
                isChange: false,
                addressData: {
                    name: "",
                    phone: "",
                    province_id: 0,
                    city_id: 0,
                    region_id: 0,
                    region: {
                        province: "",
                        city: "",
                        region: "",
                        detail: ""
                    }
                },
                // 订单续费周期
                cycle:[],
                // 订单续费记录
                renew:[],
            };
        },
        created() {
            /*获取列表*/
            this.getParams();
        },
        methods: {
            next() {
                if (this.active++ > 4) this.active = 0;
            },
            /*获取参数*/
            getParams() {
                let self = this
                // 取到路由带过来的参数
                const params = this.$route.query.order_id
                OrderApi.orderdetail({
                    order_id: params
                }).then((res) => {
                    self.loading = false
                    self.detail = res.data.detail
                    // 确保每个供应商的express_id初始值为null
                    self.detail.supplier.forEach(supplier => {
                        supplier.express_id = supplier.express_id || null
                    })
                    self.expressList = res.data.expressList
                    self.shopClerkList = res.data.shopClerkList
                    self.addressData = self.detail.address
                    self.cycle = res.data.cycle
                    self.renew = res.data.renew
                }).catch((error) => {
                    self.loading = false
                })
            },

            /*发货*/
            onSubmit() {
                let self = this;
                let param = self.detail.supplier;
                let error = '';
                for (let i = 0; i < param.length; i++) {
                    if(param[i].express_id || param[i].express_no){
                        if (!param[i].express_id || !param[i].express_no) {
                            error = '请填写完整物流公司及物流单号'
                            break
                        }
                    }
                }
                if (error) {
                    self.$message.error(error)
                    return
                }
                let order_id = this.$route.query.order_id;
                OrderApi.delivery(
                    {
                        param: param,
                        order_id: order_id
                    },
                    true
                )
                    .then((data) => {
                        self.loading = false;
                        self.$message({
                            message: "恭喜你，发货成功",
                            type: "success"
                        });
                        self.getParams();
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },

            /*确认取消*/
            confirmCancel() {
                let self = this
                let order_id = this.$route.query.order_id
                let params = JSON.parse(JSON.stringify(self.forms))
                params.order_id = order_id
                OrderApi.confirm(params, true)
                    .then((data) => {
                        self.loading = false
                        self.$message({
                            message: '恭喜你，审核成功',
                            type   : 'success'
                        })
                        self.getParams()
                    })
                    .catch((error) => {
                        self.loading = false
                    })
            },

            /*核销*/
            onExtract(e) {
                let self = this;
                let extract_form = self.extract_form;
                extract_form.order_id = e;
                OrderApi.extract(
                    {
                        extract_form
                    },
                    true
                )
                    .then((data) => {
                        self.loading = false;
                        self.$message({
                            message: "恭喜你，操作成功",
                            type: "success"
                        });
                        self.getParams();
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },
            /*虚拟商品发货*/
            onVirtual(e) {
                let self = this;
                let virtual_form = self.virtual_form;
                if (virtual_form.virtual_content == "") {
                    this.$message.error("请填写发货信息");
                    return;
                }
                virtual_form.order_id = e;
                OrderApi.virtual(
                    {
                        order_id: virtual_form.order_id,
                        virtual_content: virtual_form.virtual_content
                    },
                    true
                )
                    .then((data) => {
                        self.loading = false;
                        self.$message({
                            message: "恭喜你，操作成功",
                            type: "success"
                        });
                        self.getParams();
                    })
                    .catch((error) => {
                        self.loading = false;
                    });
            },
            /*打开编辑*/
            editClick(item) {
                this.userModel = deepClone(item);
                this.open_edit = true;
            },

            /*关闭弹窗*/
            closeDialogFunc(e, f) {
                if (f == "edit") {
                    this.open_edit = e.openDialog;
                    this.getParams();
                }
            },

            /*取消*/
            cancelFunc() {
                this.$router.back(-1);
            },
            changeAdd() {
                this.isChange = true;
            },
            closeAddress(e) {
                let self = this;
                if (e == false) {
                    self.isChange = false;
                    console.log(e);
                    return false;
                }
                let params = e.params;
                console.log(params);
                params.order_id = self.$route.query.order_id;
                OrderApi.updateAddress(params, true)
                    .then((data) => {
                        self.$message({
                            message: "修改成功",
                            type: "success"
                        });
                    })
                    .catch((error) => {});
                self.isChange = false;
            },
            changeExpress (express_id, k) {
                this.expressList.forEach(item => {
                    if (item.express_id === express_id) {
                        this.detail.supplier[k].express_company = item.express_name
                    }
                })
            }
        }
    };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/order/order/detail.vue